import { UntypedFormGroup } from '@angular/forms';
    
export function SameQuestionValidator(controlName: string, matchingControlName: string){
    return (formGroup: UntypedFormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.samequestionerror) {
            return;
        }
        if (control.value == matchingControl.value) {
            matchingControl.setErrors({samequestionerror: true});
        } else {
            matchingControl.setErrors(null);
        }
    }
}